import 'babel-polyfill'
import Es6Promise from 'es6-promise'

Es6Promise.polyfill()
import 'url-search-params-polyfill'

import "core-js/stable";
import "regenerator-runtime/runtime";

import Vue from "vue";
import "./plugins/axios";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueMeta from "vue-meta";
import elementUI from 'element-ui';
import "element-ui/lib/theme-chalk/index.css";
// 导入覆盖Element UI样式的文件
import "./assets/css/element-override.css";
import "./assets/css/recruit-info.css";
import "@/assets/css/commonCss.scss"
// 引入动画
import animated from "animate.css"
// 引入i18n国际化
import i18n from './plugins/i18n'

import vSlideIn from "@/assets/utils/vSlideIn.js";

import "normalize.css"
import "@/assets/font/fontStyle.css"
// 滚动动画 wow.js
// import { WOW } from 'wowjs'

Vue.directive('SlideIn', vSlideIn)
Vue.config.productionTip = false;

// Vue.prototype.$wow = new WOW({
//     boxClass: 'wow', // default
//     animateClass: 'animated', // default
//     offset: 0, // default
//     mobile: true, // default
//     live: false,
//
//     // live为true时，控制台会提示：MutationObserver is not supported by your browser. & WOW.js cannot detect dom mutations, please call .sync() after loading new content.
//
//     callback: function (box) {
//         // console.log("WOW: animating <" + box.tagName.toLowerCase() + ">")
//     }
// })

Vue.use(elementUI)
Vue.use(animated)
Vue.use(VueMeta)
new Vue({
    router,
    store,
    i18n, // 注册i18n
    metaInfo() {
        return {
            title: this.$store.state.metaModule.metaInfo.title,
            meta: [
                {
                    name: "keywords",
                    content: this.$store.state.metaModule.metaInfo.keywords
                }, {
                    name: "description",
                    content: this.$store.state.metaModule.metaInfo.description
                }
            ]
        }
    },
    render: (h) => h(App),
}).$mount("#app");
